// src/pages/Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import Contacto from '../ContactoComponents/Contacto';
function Home() {
  return (
    <div>
      <Contacto/>
    </div>
  );
}

export default Home;